module.exports = __webpack_public_path__ + "static/media/Picker_specifiques_elN317_841430707.670ba1e0.png";